// Cabins are named in two places that never agreed. A filter carries the name
// the backend enum uses — Economy, Business, Premium, First — while an offer
// carries the name the provider sent: Economy, Premium Economy, Business,
// First, and now and then a spelling of its own. Every comparison goes through
// here, so "Premium" and "Premium Economy" stop being two different cabins.

const ALIASES = new Map([
  ['economy', 'Economy'],
  ['economy class', 'Economy'],
  ['econom', 'Economy'],
  ['econ', 'Economy'],
  ['eco', 'Economy'],
  ['coach', 'Economy'],
  ['premium', 'Premium Economy'],
  ['premium economy', 'Premium Economy'],
  ['premiumeconomy', 'Premium Economy'],
  ['economy premium', 'Premium Economy'],
  ['premium coach', 'Premium Economy'],
  ['premium eco', 'Premium Economy'],
  ['business', 'Business'],
  ['business class', 'Business'],
  ['biz', 'Business'],
  ['first', 'First'],
  ['first class', 'First'],
]);

const unknownValues = new Set();

// Returns null for anything we cannot name, an empty value included: callers
// read that as "no cabin stated", never as a cabin of its own.
export function normalizeCabin(value) {
  if (value === null || value === undefined) return null;

  const key = String(value).trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
  if (!key) return null;
  if (ALIASES.has(key)) return ALIASES.get(key);

  // A spelling no provider has shown us before. Worth knowing about, never
  // worth emptying the results over.
  if (!unknownValues.has(key)) {
    unknownValues.add(key);
    console.warn(`Unknown cabin value: ${JSON.stringify(value)}`);
  }

  return null;
}

// A fare belongs to a cabin only when every leg of it does: "business there,
// economy back" is not a business fare. A fare that states no cabin at all
// cannot be judged, so it stays — some payloads carry no cabin to compare.
export function fareMatchesCabin(fare, cabin) {
  const wanted = normalizeCabin(cabin);
  if (!wanted) return true;

  const legs = (fare?.fare_segments || [])
    .map((segment) => normalizeCabin(segment?.cabin_class))
    .filter(Boolean);

  if (legs.length) return legs.every((leg) => leg === wanted);

  const stated = normalizeCabin(fare?.cabin);

  return stated === null || stated === wanted;
}
